import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'

import { Colors } from '@sigma-frontend-libs/commons'

import { balance, createClicker, generateServices, globalErrorHandler, globalErrorProcessor, isUUID, services } from '@/utils'

import generatorSearch from '@/components/generator/search'
import { inputFilter, outputFilter } from '@/components/services/users/utils'
import templateLegacy from '@/components/templates/legacy'

import render from './render'

export default {
  name: services.users,

  mixins: [
    balance(),
    generateServices([
      {
        name: services.billings,

        inputFilter(result) {
          result.amount = 10

          return result
        },

        outputFilter(result) {
          if (result.source !== 'accrual') {
            result.amount = result.amount * -1
          }

          result.amount = parseFloat(result.amount)

          return result
        },

        get: false,
        find: false,
        update: false,
        remove: false
      },
      {
        name: services.users,

        inputFilter,
        outputFilter,

        create: {
          redirect: true,
          params: {
            query: {
              $scope: [ 'full' ]
            }
          }
        },

        find: false,
        get: false,
        update: false,
        remove: false
      }
    ])
  ],

  components: {
    'search-generator': generatorSearch({
      name: services.users,

      find: {
        defaultFilter: {
          isActive: true
        },
        params: {
          query: {
            $scope: [ 'full' ]
          }
        }
      },
      avoid304: true
    }),

    'get-create-template': templateLegacy({
      name: services.users,

      inputFilter,
      outputFilter,

      find: false,
      get: {
        params: {
          query: {
            $scope: [ 'full' ]
          }
        }
      },
      update: {
        params: {
          query: {
            $scope: [ 'full' ]
          }
        }
      },
      create: false,
      remove: {
        redirect: true,
        params: {
          query: {
            $scope: [ 'full' ]
          }
        }
      }
    })
  },

  data() {
    return {
      showUserCreateDialog: false,
      showAddFundsDialog: false,
      showTokenDialog: false,

      tab: undefined,
      token: undefined
    }
  },

  computed: {
    ...mapGetters({ statusLoginAs: 'login/status' }),

    createDataIsValid() {
      return this.restData.billings.create.state !== 'loading' && this.restData.billings.create.isValid
    },

    tabs() {
      const result = []
      if (this.checkPermissions(`advanced.${services.userComments}.get`)) {
        result.push(services.userComments)
      }
      if (this.checkPermissions(`advanced.${services.eventsHistory}.get`)) {
        result.push(services.eventsHistory)
      }

      return result.map(key => {
        return {
          key,
          title: this.getTranslate(`${services.users}.tabs.${key}`)
        }
      })
    }
  },

  mounted() {
    this.tab = this.tabs[0]?.key
  },

  methods: {
    ...mapActions({ loginAs: 'login/loginAs' }),

    clickHandler: createClicker({
      shortClickHandler(event) {
        if (event.shiftKey) {
          this.showUserToken()
        } else {
          this.loginAs(this.$route.params.id)
        }
      },

      longClickHandler() {
        this.showUserToken()
      },

      longClickPreFire: true
    }),

    async showUserToken() {
      try {
        if (isUUID(this.$route.params.id)) {
          const result = await Vue.$GRequest.get('login/as', this.$route.params.id)
          if (result && result.status === 200) {
            this.token = result.data.token
            this.showTokenDialog = true
          }
        }
      } catch (error) {
        globalErrorHandler.call(this, globalErrorProcessor.call(this, error))
      }
    },
    closeTokenDialog() {
      this.showTokenDialog = false
      this.token = undefined
    },
    copyToken() {
      navigator.clipboard.writeText(this.token)
      this.addSnackbar({
        text: this.getTranslate('misc.copied'),
        color: Colors.success
      })
      this.closeTokenDialog()
    },

    async createBilling() {
      if (this.createDataIsValid) {
        try {
          const result = await this.rest.billings.create(this.restData.billings.create.data)
          if (result) {
            this.showAddFundsDialog = false
          }
        } catch (error) {
          globalErrorHandler.call(this, globalErrorProcessor.call(this, error))
        }
      }
    },

    async createUser() {
      if (this.restData[services.users].create.isValid) {
        try {
          const result = await this.rest[services.users].create(this.restData[services.users].create.data)
          if (result) {
            this.showUserCreateDialog = false
          }
        } catch (error) {
          globalErrorHandler.call(this, globalErrorProcessor.call(this, error))
        }
      }
    }
  },

  render
}
